import { React, useState, useEffect } from 'react';// adjust this import path to where your JSONTableEditor file is located
import { Dialog, Select, MenuItem, DialogActions,  DialogContent, DialogContentText, DialogTitle, Button, IconButton, Tooltip, TextField } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import DynamicForm from '../../DynamicForm';
import JSONTableEditor from '../../JSONTableEditor';
import CentralCalls from '../../../centralCalls';
import { useTheme } from '@mui/styles';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Modal from 'react-modal';
import DeleteConfirmationPopup from '../../DeleteConfirmationPopup';
import ActivePhase from '../parts/activePhase';
import CompletePhase from '../parts/completedPhase';
import DeletedPhase from '../parts/deletedPhase';
import OnHoldPhase from '../parts/onHoldPhase';
import LotFilter from '../../workInProgress/LotFilter';
import ActivePhaseButtonGroup from '../activePhaseButtonGroup';
import WipPhaseFilesDialog from '../../workInProgress/WipPhaseFilesDialog';
import { Auth } from 'aws-amplify';
const useStyles = makeStyles(theme => ({
  customHeader: {
    borderRadius: '10px',
    fontSize: 'large',
    padding: '0px',
    margin: '0px',
    border: 'black solid'
  }
}))
const BasePhase = ({ phaseType }) => {
  const classes = useStyles();
  const [StatusDialogOpen, setStatusDialogOpen] = useState(false);
  const [UndergroundDialogOpen, setUndergroundDialogOpen] = useState(false);
  const [addQCDialogOpen, setAddQCDialogOpen] = useState(false);
  const [PunchDialogOpen, setPunchDialogOpen] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [refreshMenuKey, setRefreshMenuKey] = useState(false);
  const [LotOid, setLotOid] = useState(null);
  const [filter,setFilter] = useState({name_id : 'open', name : 'Open'});
  const [filterStartDate, setFilterStartDate] = useState(new Date());
  const [filterEndDate, setFilterEndDate] = useState(new Date());
  const [PhaseOid, setPhaseOid] = useState(null);
  const [lotTitle, setLotTitle] = useState('not title');
  const [punchLotOid, setPunchLotOid] = useState(null);
  const [failedQCPoNumber, setFailedQCPoNumber] = useState('');
  const [failedQCCost, setFailedQCCost] = useState('');
  // New: punch form fields (Requested Date, Comments, Crew)
  const [punchRequestedDate, setPunchRequestedDate] = useState('');
  const [punchComments, setPunchComments] = useState('');
  const [punchTeams, setPunchTeams] = useState([]);
  const [punchTeamOid, setPunchTeamOid] = useState('');
  const [punchFiles, setPunchFiles] = useState([]);
  const [isUploadingPunchFiles, setIsUploadingPunchFiles] = useState(false);
  const [punchUploadUserName, setPunchUploadUserName] = useState('unknown');
  const [refreshUndergroundKey, setRefreshUndergroundKey] = useState(0);
  const [AddQCValid, setAddQCValid] = useState(null);
  const [NewQCLotOid, setNewQCLotOid] = useState(0);
  const [selectedPhaseForQC, setSelectedPhaseForQC] = useState(0);
  const [selectedSecondaryPhaseForQC, setSelectedSecondaryPhaseForQC] = useState('slab_inspection');
  const [qcPhaseOptions, setQcPhaseOptions] = useState([]);
  const [secondaryInspectionLotOid,setSecondaryInspectionLotOid] = useState(0);
  const [phaseName, setPhaseName] = useState('');
  const [isQc, setIsQc] = useState(0);
  const [isInspection, setIsInspection] = useState(0);
  const [phaseMetaData, setPhaseMetaData] = useState(null);
  const [qcTitle, setQcTitle] = useState('UNSET');
  const [phaseFilesDialogOpen, setPhaseFilesDialogOpen] = useState(false);
  const [selectedPhaseFileOid, setSelectedPhaseFileOid] = useState(null);
  const [selectedPhaseFileLotOid, setSelectedPhaseFileLotOid] = useState(null);
  const navigate = useNavigate(); 

  useEffect(() => {
    const fetchData = async () => {
      const phase_nm = await CentralCalls.fetchTableData('phase_type', { name_id: phaseType });
      setPhaseMetaData(phase_nm[0]);
      setPhaseName(phase_nm[0].name);
      setIsQc(phase_nm[0].is_qc);
      setIsInspection(phase_nm[0].is_inspection);
      if (phase_nm[0].is_inspection === 1) {
        setQcTitle("Add Inspection");
      } else {
        setQcTitle("Add Quality Check");
      }
    };

    fetchData();
  }, [phaseType], [isInspection]);
  useEffect(() => {
    const getLotTitle = async () => {
      const title = await CentralCalls.callStoredProcedureWithParams('sp_getLotTitle', { lot_oid: LotOid });
      setLotTitle(title.title);
    }
    getLotTitle();
  }, [LotOid]);
useEffect(() => {
    const fetchData = async () => {
        const phase_nm = await CentralCalls.fetchTableData('phase_type', { name_id: phaseType });
        setPhaseName(phase_nm[0].name);
        setIsQc(phase_nm[0].is_qc);
        setIsInspection(phase_nm[0].is_inspection);
        if (phase_nm[0].is_inspection === 1) {
            setQcTitle("Add Inspection");
        } else {
            setQcTitle("Add Quality Check");
        }
    };

    fetchData();
}, [phaseType], [isInspection]);

  useEffect(() => {
    const setUserInfo = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        setPunchUploadUserName(user?.attributes?.email || user?.username || 'unknown');
      } catch (error) {
        console.error('Error fetching user info', error);
        setPunchUploadUserName('unknown');
      }
    };

    setUserInfo();
  }, []);
  const ConfirmationModal = ({ isOpen, onClose, onConfirm }) => {
    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={onClose}
        contentLabel="Confirmation Modal"  >
        <h2>Confirm</h2>
        <p>Are you sure you want to proceed?</p>
        <button onClick={onConfirm}>Yes</button>
        <button onClick={onClose}>No</button>
      </Modal>
    );
  };
  const closePunchDialog = async () => {
    setPunchDialogOpen(false);
    setPunchLotOid(null);
    // clear punch form state
    setPunchRequestedDate('');
    setPunchComments('');
    setPunchTeamOid('');
    setPunchTeams([]);
    setPunchFiles([]);
  }
  const handleLotSelected = async (lot_oid) => {
    setPunchLotOid(lot_oid);
  }
  // fetch crews when the punch dialog opens
  useEffect(() => {
    if (!PunchDialogOpen) return;
    const fetchTeams = async () => {
      try {
        const rows = await CentralCalls.fetchTableData('employee_team', {});
        setPunchTeams(rows || []);
      } catch (err) {
        console.error('Error fetching teams', err);
        setPunchTeams([]);
      }
    };
    fetchTeams();
  }, [PunchDialogOpen]);
 
   const handleWipLinkClick = async (phaseRow) => {
     const path = '/wip?lot_oid=' + phaseRow.lot_oid;
     navigate(path);
   }
   
   const refreshMenu = async () => {
    console.log('freshing menu key base')
    setRefreshMenuKey(!refreshMenuKey);
   }

  const handleOpenPhaseFilesClick = async (phaseRow) => {
    setSelectedPhaseFileOid(phaseRow.phase_oid || null);
    setSelectedPhaseFileLotOid(phaseRow.lot_oid || null);
    setPhaseFilesDialogOpen(true);
  }

  const checkDisplayPhaseFiles = (phaseRow) => {
   
    const countField = phaseRow.file_count ?? phaseRow.files_count ?? phaseRow.phase_file_count ?? phaseRow.file_cnt;
    const hasField = phaseRow.has_files;
    if (typeof countField === 'number') {
      return countField > 0;
    }
    if (typeof countField === 'string' && countField.trim() !== '') {
      const parsed = parseInt(countField, 10);
      if (!Number.isNaN(parsed)) {
        return parsed > 0;
      }
    }
    if (typeof hasField === 'number') {
      return hasField === 1;
    }
    if (typeof hasField === 'boolean') {
      return hasField;
    }
    if (typeof hasField === 'string') {
      return hasField === '1' || hasField.toLowerCase() === 'true';
    }
    return false;
  }
  // const handleCompleteUndergroundClose = async (undergroundRow) => {
  //   setUndergroundDialogOpen(false);
  // }
  // const handleSavePhaseStatus = async (phaseRow) => {
  //    setStatusDialogOpen(!StatusDialogOpen);
  // }

  const onFilterSelect  = async (filter) => {
        setFilter(filter.filter);
        setFilterStartDate(filter.startDate);
        setFilterEndDate(filter.endDate);
        console.log('refreshing menu');
        setRefreshMenuKey(refreshMenuKey + 1)
  }

  const addPunch = async () => {
    setPunchDialogOpen(true);
  }

  const handlePunchFilesChange = async (event) => {
    const selectedFiles = Array.from(event.target.files || []);
    setPunchFiles(selectedFiles);
  }

  const uploadPunchFilesForPhase = async (phaseOid, lotOid) => {
    if (!phaseOid || !lotOid || !punchFiles || punchFiles.length === 0) {
      return;
    }

    setIsUploadingPunchFiles(true);
    try {
      for (const file of punchFiles) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('lot_oid', lotOid);
        formData.append('uploaded_by', punchUploadUserName || 'unknown');

        const response = await fetch('/api/files/upload', {
          method: 'POST',
          body: formData,
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.error || `Upload failed for ${file.name}`);
        }

        const savedFileRow = await response.json();
        if (savedFileRow?.oid) {
          await CentralCalls.upsertData({ oid: savedFileRow.oid, phase_oid: phaseOid }, 'files', 'update');
        }
      }
    } finally {
      setIsUploadingPunchFiles(false);
    }
  }

  const OpenQCDialogOpen = async () => {
    setAddQCDialogOpen(true);
    setQcPhaseOptions([]);
    setSelectedPhaseForQC(0);
    setAddQCValid(false);
  }
  const handleAddPunchClick = async () => {
    if (!punchLotOid) return;
    console.log('Adding punch for lot_oid:', punchLotOid);
    console.log(phaseType);
    console.log(punchComments);
    console.log(punchRequestedDate)
    const teamVal = punchTeamOid ? parseInt(punchTeamOid, 10) : null;
    var newPhase = null;
    try {
      if (teamVal) {
        newPhase = await CentralCalls.upsertData({
          lot_oid: punchLotOid,
          phase_type: phaseType,
          is_punch: 1,
          punch_comments: punchComments,
          builder_date: punchRequestedDate,
          date_scheduled: punchRequestedDate
        }, 'phase', 'insert');
        await CentralCalls.upsertData({ phase_oid: newPhase.oid, comments: punchComments, employee_team_oid: teamVal }, 'phase_status', 'insert');
      } else {
        newPhase = await CentralCalls.upsertData({
          lot_oid: punchLotOid,
          phase_type: phaseType,
          is_punch: 1,
          punch_comments: punchComments,
          builder_date: punchRequestedDate
        }, 'phase', 'insert');
        await CentralCalls.upsertData({ phase_oid: newPhase.oid, comments: punchComments }, 'phase_status', 'insert');
      }
      if (failedQCPoNumber || ((failedQCCost && failedQCCost > 0))) {
          await CentralCalls.upsertData({ phase_oid: newPhase.oid, po_number: failedQCPoNumber, price: failedQCCost ? parseFloat(failedQCCost) : null, phase_type: phaseType, comments: punchComments }, 'po', 'insert');
      }
      if (newPhase?.oid && punchLotOid && punchFiles.length > 0) {
        try {
          await uploadPunchFilesForPhase(newPhase.oid, punchLotOid);
        } catch (uploadErr) {
          console.error('Error uploading punch files', uploadErr);
          alert(uploadErr?.message || 'Punch created, but one or more files failed to upload.');
        }
      }
      closePunchDialog();
      setRefresh(new Date().getTime());
      refreshMenu();
      setFailedQCPoNumber('');
      setFailedQCCost('');
    } catch (err) {
      console.error('Error adding punch', err);
      closePunchDialog();
      refreshMenu();
    }
  }
  const setQCPhaseOptions  = async (selected_lot_oid, secondary_phase_type) => {
    const qcForPhaseType = phaseType.split('_')[0];
    var this_phase_type = qcForPhaseType;
    if (isInspection === 1) {
      this_phase_type = secondary_phase_type.split('_')[0];
    }
    //console.log({ lot_oid: parseInt(lot), phase_type: this_phase_type, is_inspection : isInspection, inspection_phase_type : selectedSecondaryPhaseForQC })
    const result = await CentralCalls.callStoredProcedureWithParams('sp_checkLotExistingQC', { lot_oid: parseInt(selected_lot_oid), phase_type: this_phase_type, is_inspection: isInspection, inspection_phase_type: secondary_phase_type });
    if (!result || result.length === 0) {
      setQcPhaseOptions([], selectedSecondaryPhaseForQC);
      //CentralCalls.upsertData({ deleted: 0, oid: deletedRow.oid }, 'permit', 'update');
      //setAddQCValid(false);         
    } else {
      setNewQCLotOid(selected_lot_oid);
      //setAddQCValid(true);
      setQcPhaseOptions(result,selectedSecondaryPhaseForQC);
    }
  }
  const confirmLotQCAddOption = async (lot) => {
    setQCPhaseOptions(lot, selectedSecondaryPhaseForQC);
    setSecondaryInspectionLotOid(lot);
  }
  const insertNewQC = async () => {
    var phase_type_now = phaseType;
    if(isInspection){
      phase_type_now = selectedSecondaryPhaseForQC;
    }
    const phaseRow = await CentralCalls.upsertData({ lot_oid: NewQCLotOid, phase_type: phase_type_now, qc_phase_oid: selectedPhaseForQC }, 'phase', 'insert');
    await CentralCalls.upsertData({ 'phase_oid': phaseRow.oid }, 'phase_status', 'insert');
    setAddQCDialogOpen(false);
  }
  const handleSelectedPhaseForQCChange = async (event) => {
    const oid = event.target.value;
    if (oid !== 0) {
      setAddQCValid(true);
    }
    else {

    }
    setSelectedPhaseForQC(oid);
  }
  const handleSelectedSecondaryPhaseForQCChange = async (event) => {
    const phase_type = event.target.value;
    if (isInspection && selectedSecondaryPhaseForQC === 0) {
      setAddQCValid(true);
    }
    await setSelectedSecondaryPhaseForQC(phase_type);
    setQCPhaseOptions(secondaryInspectionLotOid, phase_type);
  }

  // const customFunctionsEmpty = [

  // ]

  // const procedureDetailsUndergroundHistory = {
  //   procedureName: 'ui_sp_wipUndergroundTickets',
  //   parameters: { lot_oid: LotOid },
  // }
  // const handleSaveUndergroundHistory = async (phaseRow) => { }

  // const procedureDetailsUndergroundTickets = {
  //   procedureName: 'ui_getUndergroundTickets',
  //   parameters: { phase_oid: PhaseOid, lot_oid: LotOid }
  // }

  return (
    <>
      <h2> {phaseName === 'Slab Inspection' ? 'Inspections' : phaseName}
        {isQc !== 1 && (
          <Tooltip title="Add Punch">
            <IconButton color="primary" aria-label="save" onClick={addPunch} size="medium">
              <FontAwesomeIcon icon={faPlus} />
            </IconButton>
          </Tooltip>
        )}
        {isQc === 1 && (
          <Tooltip title={qcTitle}>
            <IconButton color="primary" aria-label="save" onClick={() => { OpenQCDialogOpen() }} size="medium">
              <FontAwesomeIcon icon={faPlus} />
            </IconButton>
          </Tooltip>
        )}
      </h2>
       
      <ActivePhaseButtonGroup refreshMenuKey={refreshMenuKey} phaseType={phaseType} theme={phaseMetaData} onFilterSelect={onFilterSelect} ></ActivePhaseButtonGroup>
       <h3>{filter.name}</h3>
       {(['scheduled', 'open', 'upcoming'].includes(filter.name_id) && (
        <ActivePhase
          refreshMenu={refreshMenu}
          isQc={isQc}
          isInspection={isInspection}
          filterType={filter.name_id }
          phaseType={phaseType}
          handleWipLinkClick={handleWipLinkClick}
          handleOpenPhaseFilesClick={handleOpenPhaseFilesClick}
          checkDisplayPhaseFiles={checkDisplayPhaseFiles}
        />
       ))}

      {filter.name_id === 'hold' && (
        <OnHoldPhase
          refreshMenu={refreshMenu}
          endDate={filterEndDate}
          startDate={filterStartDate}
          phaseType={phaseType}
          handleWipLinkClick={handleWipLinkClick}
          handleOpenPhaseFilesClick={handleOpenPhaseFilesClick}
          checkDisplayPhaseFiles={checkDisplayPhaseFiles}
        />
      )}

      {filter.name_id === 'complete' && (
        <CompletePhase
          key={refreshMenuKey}
          refreshMenu={refreshMenu}
          endDate={filterEndDate}
          startDate={filterStartDate}
          phaseType={phaseType}
          handleWipLinkClick={handleWipLinkClick}
          isQc={isQc}
          handleOpenPhaseFilesClick={handleOpenPhaseFilesClick}
          checkDisplayPhaseFiles={checkDisplayPhaseFiles}
        />
      )}

      {filter.name_id === 'deleted' && (
        <DeletedPhase
          refreshMenu={refreshMenu}
          endDate={filterEndDate}
          startDate={filterStartDate}
          phaseType={phaseType}
          handleWipLinkClick={handleWipLinkClick}
          handleOpenPhaseFilesClick={handleOpenPhaseFilesClick}
          checkDisplayPhaseFiles={checkDisplayPhaseFiles}
        />
      )}


            <Dialog fullWidth={true} maxWidth='lg' open={PunchDialogOpen} onClose={() => closePunchDialog()}>
                <DialogContent >
                    <>
                        <h2>{phaseName} Punch</h2>
                        <LotFilter onLotChange={handleLotSelected} />
                        {/* Requested Date (required) */}
                        <TextField
                            margin="normal"
                            label="Requested Date"
                            type="date"
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            value={punchRequestedDate}
                            onChange={(e) => setPunchRequestedDate(e.target.value)}
                        />
                        {/* Comments */}
                        <TextField
                            margin="normal"
                            label="Comments"
                           
                            fullWidth
                            value={punchComments}
                            onChange={(e) => setPunchComments(e.target.value)}
                        />
                        {/* Crew select */}
                        <TextField
                            margin="normal"
                            label="Crew"
                            select
                            fullWidth
                            value={punchTeamOid}
                            onChange={(e) => setPunchTeamOid(e.target.value)}
                        >
                            <MenuItem value="">
                                <em>None</em>
                            </MenuItem>
                            {punchTeams
                                .slice()
                                .sort((a, b) => (a.name || '').localeCompare(b.name || ''))
                                .map((t) => (
                                    <MenuItem key={t.oid} value={t.oid}>{t.name}</MenuItem>
                            ))}
                        </TextField>

                          <div style={{ marginTop: 8, marginBottom: 8 }}>
                            <label style={{ display: 'block', fontWeight: 500 }}>Files</label>
                            <input
                              id="punch-file-input"
                              type="file"
                              multiple
                              onChange={handlePunchFilesChange}
                            />
                            {punchFiles.length > 0 && (
                              <div style={{ marginTop: 6 }}>
                                <label>{punchFiles.length} file(s) selected:</label>
                                <ul style={{ marginTop: 4 }}>
                                  {punchFiles.map((file) => (
                                    <li key={`${file.name}-${file.size}-${file.lastModified}`}>{file.name}</li>
                                  ))}
                                </ul>
                              </div>
                            )}
                          </div>
                        
                        <div style={{ marginTop: 8, marginBottom: 8 }}>
                                                 <label style={{ display: 'block', fontWeight: 500 }}>PO</label>
                                                 <TextField
                                                     margin="normal"
                                                     label="PO Number"
                                                     fullWidth
                                                     value={failedQCPoNumber}
                                                     onChange={(e) => setFailedQCPoNumber(e.target.value)}
                                                 />
                                                 <TextField
                                                     margin="normal"
                                                     label="Cost"
                                                     type="number"
                                                     inputProps={{ step: "0.01", min: 0 }}
                                                     fullWidth
                                                     value={failedQCCost}
                                                     onChange={(e) => setFailedQCCost(e.target.value)}
                                                 />
                                             </div>
                                             
                        <Button variant="contained" type="submit" color="primary" onClick={handleAddPunchClick} disabled={punchLotOid == null || !punchRequestedDate || isUploadingPunchFiles} >
                          {isUploadingPunchFiles ? 'Uploading Files...' : 'Add Punch'}
                        </Button>
                    </>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => closePunchDialog()} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog fullWidth={true} maxWidth='lg' open={addQCDialogOpen} onClose={() => setAddQCDialogOpen(false)}>
                <DialogTitle><h1>{qcTitle}</h1></DialogTitle>
                <DialogContent >
                    <LotFilter onLotChange={confirmLotQCAddOption}></LotFilter>
                    {isInspection === 1 && (
                        <Select style={{ marginLeft: '25px' }}
                            onChange={handleSelectedSecondaryPhaseForQCChange}
                            value={selectedSecondaryPhaseForQC}>
                            <MenuItem key={'confirm_11'} value={'slab_inspection'}>
                                Slab Inspection
                            </MenuItem>
                            <MenuItem key={'confirm_12'} value={'underground_inspection'}>
                                Underground Inspection
                            </MenuItem>
                            <MenuItem key={'confirm_13'} value={'rough_inspection'}>
                                Rough Inspection
                            </MenuItem>
                            <MenuItem key={'confirm_14'} value={'setout_inspection'}>
                                Setout Inspection
                            </MenuItem>
                        </Select>
                    )}

                    <Select style={{ marginLeft: '25px' }}
                        onChange={handleSelectedPhaseForQCChange}
                        value={selectedPhaseForQC}>
                        <MenuItem key={-1} value={0}>
                            SELECT
                        </MenuItem>
                        {qcPhaseOptions &&
                            qcPhaseOptions.slice().sort((a, b) => a.phase_type.localeCompare(b.phase_type)) // Sort Builders inline
                                .map((phase) => (
                                    <MenuItem key={phase.oid} value={phase.oid}>
                                {phase.phase_type + '  '}  {CentralCalls.normalizeDateOnly(phase.date_scheduled)}
                                    </MenuItem>
                                ))}
                    </Select>
                    <br />
                    <Button style={{ margin: '15px' }} variant="contained" color="primary" type="submit" disabled={AddQCValid === false || AddQCValid === null || selectedPhaseForQC === null || selectedPhaseForQC === 0} onClick={() => insertNewQC()}  >Insert</Button>
                    {/* {AddQCValid === false && (<><br /><label style={{ color: 'red' }}>Existing Quality Check For This Lot</label></>)} */}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setAddQCDialogOpen(false); setQcPhaseOptions([], selectedSecondaryPhaseForQC); }} >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
            <WipPhaseFilesDialog
              open={phaseFilesDialogOpen}
              onClose={() => setPhaseFilesDialogOpen(false)}
              phaseOid={selectedPhaseFileOid}
              selectedLotOid={selectedPhaseFileLotOid}
            />
    </>
  );
};
export default BasePhase;